import { render } from "./StudentsTable.vue?vue&type=template&id=56d2ec8a&scoped=true"
import script from "./StudentsTable.vue?vue&type=script&lang=js"
export * from "./StudentsTable.vue?vue&type=script&lang=js"

import "./StudentsTable.vue?vue&type=style&index=0&id=56d2ec8a&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d2ec8a"]])

export default __exports__